import React, { Component } from "react"
import { connect } from "react-redux"
import { authorize } from "../decorators/authorize"
import requireStore from "../decorators/requireStore"
import { cashboxPage } from "../config/routesInfo"
import CashboxCard from "../components/cashBoxCard"
import CashboxHolder from "../components/cashboxHolder"
import Info from "../components/Info"
import {
  createCashbox,
  deleteCashbox,
  editCashbox,
  refresh,
  fiscalCashbox,
} from "../ducks/cashbox.js"
import { Button, Grid, Icon } from "semantic-ui-react"
import bind from "bind-decorator"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"

@authorize(...cashboxPage.permissions)
@requireStore()
@withRouter
@withTranslation()
@connect(
  (state) => ({
    loadingCashboxIds: state.cashbox.loadingCashboxIds,
    data: state.cashbox.data,
    currentStoreId: state.profile.currentStore.id,
    storeOptions: state.profile.stores.map((s) => ({
      value: s.id,
      text: s.name,
      name: s.name,
      key: s.id,
    })),
    login: state.profile.login,
    isLoading: state.cashbox.isLoading,
  }),
  (dispatch) => ({
    refresh: () => dispatch(refresh()),
    deleteCashbox: (...data) => dispatch(deleteCashbox(...data)),
    editCashbox: (...data) => dispatch(editCashbox(...data)),
    createCashbox: (...data) => dispatch(createCashbox(...data)),
    fiscalCashbox: (...data) => dispatch(fiscalCashbox(...data)),
  }),
)
export default class СashboxPage extends Component {
  state = {
    creating: false,
    open: true,
    cashOpen: true,
    wannaFiscal: false,
    wkLogin: "",
    pass: "",
    serialNumber: "",
    npfu: "",
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(newProps) {
    const { currentStoreId, refresh } = this.props
    if (newProps.currentStoreId !== currentStoreId) {
      refresh()
    }
  }

  componentDidMount() {
    this.props.refresh()
  }

  @bind
  onStartCreating() {
    this.setState({
      creating: true,
    })
  }

  @bind
  cancelCreating() {
    this.setState({
      creating: false,
      open: false,
    })
  }

  @bind
  toFiscal() {
    this.setState({
      wannaFiscal: !this.state.wannaFiscal,
    })
  }

  @bind
  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  render() {
    const { t } = this.props
    const { creating } = this.state
    const {
      data,
      isLoading,
      editCashbox,
      createCashbox,
      deleteCashbox,
      refresh,
      currentStoreId,
      loadingCashboxIds,
      storeOptions,
      fiscalCashbox,
      login,
    } = this.props
    if (isLoading) {
      return <h1 style={{ textAlign: "center" }}>{t("Data loading")}...</h1>
    }
    return (
      <>
        {data.length === 0 && (
          <>
            <h2>
              {t("cashboxPage")}
              <Info
                text={
                  <div>
                    <p>
                      {t(
                        "In this section you can work with your cash registers, namely",
                      )}
                    </p>
                    <ul>
                      <li>{t("Create new cash desks")}</li>
                      <li>{t("Delete existing cash desks")}</li>
                      <li>{t("Edit Title")}</li>
                      <li>{t("Turn on / off cash desks")}</li>
                      <li>{t("Fiscalize cash registers")}</li>
                    </ul>
                  </div>
                }
              />
              <Button basic icon disabled={isLoading} onClick={refresh}>
                <Icon name="refresh" link loading={isLoading} />
              </Button>
              <Button color="green" onClick={this.onStartCreating}>
                {t("add")}
              </Button>
            </h2>
            {creating && (
              <Grid>
                <Grid.Row centered>
                  <Grid.Column computer={8} tablet={16}>
                    <CashboxCard
                      storeOptions={storeOptions}
                      isCreate
                      // create={creating}
                      createCashbox={createCashbox}
                      editCashbox={editCashbox}
                      cancelCreating={this.cancelCreating}
                      storeId={currentStoreId}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            )}
          </>
        )}
        {data.length === 1 && (
          <div>
            <h2>
              {t("cashboxPage")}
              <Info
                text={
                  <div>
                    <p>
                      {t(
                        "In this section you can work with your cash registers, namely",
                      )}
                    </p>
                    <ul>
                      <li>{t("Create new cash desks")}</li>
                      <li>{t("Delete existing cash desks")}</li>
                      <li>{t("Edit Title")}</li>
                      <li>{t("Turn on / off cash desks")}</li>
                      <li>{t("Fiscalize cash registers")}</li>
                    </ul>
                  </div>
                }
              />
              <Button basic icon disabled={isLoading} onClick={refresh}>
                <Icon name="refresh" link loading={isLoading} />
              </Button>
              <Button color="green" onClick={this.onStartCreating}>
                {t("add")}
              </Button>
            </h2>
            {creating && (
              <Grid>
                <Grid.Row centered>
                  <Grid.Column computer={8} tablet={16}>
                    <CashboxCard
                      storeOptions={storeOptions}
                      isCreate
                      // create={creating}
                      createCashbox={createCashbox}
                      editCashbox={editCashbox}
                      cancelCreating={this.cancelCreating}
                      storeId={currentStoreId}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            )}
            <CashboxHolder
              data={data}
              editCashbox={editCashbox}
              deleteCashbox={deleteCashbox}
              createCashbox={createCashbox}
              fiscalCashbox={fiscalCashbox}
              refresh={refresh}
              storeId={currentStoreId}
              login={login}
              loadingCashboxIds={loadingCashboxIds}
            />
          </div>
        )}

        {data.length > 1 && (
          <div>
            <h2>
              {t("cashboxPage")}
              <Info
                text={
                  <div>
                    <p>
                      {t(
                        "In this section you can work with your cash registers, namely",
                      )}
                    </p>
                    <ul>
                      <li>{t("Create new cash desks")}</li>
                      <li>{t("Delete existing cash desks")}</li>
                      <li>{t("Edit Title")}</li>
                      <li>{t("Turn on / off cash desks")}</li>
                      <li>{t("Fiscalize cash registers")}</li>
                    </ul>
                  </div>
                }
              />
              <Button basic icon disabled={isLoading} onClick={refresh}>
                <Icon name="refresh" link loading={isLoading} />
              </Button>
              <Button color="green" onClick={this.onStartCreating}>
                {t("add")}
              </Button>
            </h2>
            {creating && (
              <Grid>
                <Grid.Row centered>
                  <Grid.Column computer={8} tablet={16}>
                    <CashboxCard
                      storeOptions={storeOptions}
                      isCreate
                      // create={creating}
                      createCashbox={createCashbox}
                      editCashbox={editCashbox}
                      cancelCreating={this.cancelCreating}
                      storeId={currentStoreId}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            )}
            <CashboxHolder
              data={data}
              editCashbox={editCashbox}
              deleteCashbox={deleteCashbox}
              createCashbox={createCashbox}
              fiscalCashbox={fiscalCashbox}
              refresh={refresh}
              storeId={currentStoreId}
              login={login}
              loadingCashboxIds={loadingCashboxIds}
            />
          </div>
        )}
      </>
    )
  }
}
